const VerticalDivider = function AddIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="17" viewBox="0 0 2 17" fill="none">
            <path d="M1.46278 1.34906V16.0096" stroke="#DDDDDD" stroke-linecap="square" />
        </svg>
    );
};
export default VerticalDivider;